import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import "./patientSelfReported.scss";
import { withRouter } from "react-router";
import { RightOutline } from "antd-mobile-icons";
import type { RouteComponentProps } from "react-router-dom";
import { ApiCore } from "../../api";
import { Toast, Modal, ActivityIndicator } from "antd-mobile";
import ImagePicker from "../../component/image-picker";
import { PhotoSlider } from "react-photo-view";
import { createFromIconfontCN } from "@ant-design/icons";
import {
  makeUploadName,
  makeUploadOptions,
} from "../../component/ocr-autofill/utils";
import saveBtn from "../../static/icon/saveBtn.svg";
import OSS from "ali-oss";

const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
  scriptUrl: [
    "//at.alicdn.com/t/font_2323742_xvjwsudf76n.js",
    "//at.alicdn.com/t/font_2857469_i2b7j58rf1.js",
  ],
});
interface SelfReportProps extends RouteComponentProps<{ id: string }> {
  selfReportedList: ReportItem[];
  refresh: (visitId: string) => void;
  visitId: string;
  editModel: number
}

interface ReportItem {
  id: string;
  name: string;
  reportState: 0 | 1 | 2;
  code: string;
  updateTime: string;
  arrival: Boolean;
  isLook: boolean;
  url: null | string[];
}
interface scaleItem {
  id: string;
}

const PatientSelfReported = (props: SelfReportProps) => {
  //设置加载状态
  const [loading, setLoading] = useState(false);
  const { selfReportedList, refresh, visitId, editModel } = props;
  const [bindState, setBindState] = useState<any>(0);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [filesList, setFilesList] = useState<any>([]);
  const [scale, setScale] = useState<scaleItem>({
    id: "",
  });
  //图片预览是否显示
  const [photoVisible, setPhotoVisible] = useState(false);
  //当前预览图片的index
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState<any>(0);
  const mPhotoRef = useRef(null);
  const subjectCode = props.match.params.id;
  useEffect(() => {
    if (!subjectCode) return;
    subjectBindState(subjectCode);
  }, [subjectCode]);

  const onPhotoChange = (files: any) => {
    setFilesList(files);
  };
  const onConfirm = (files: any) => {
    api
      .scaleUpload({
        id: scale.id,
        url: files.map((e: any) => e.url),
      })
      .then(() => {
        refresh(visitId);
      })
      .catch((err) => {
        Toast.fail(err.message);
      });
  };
  const onUpload = async (item: any): Promise<object | undefined> => {
    // setLoading(true);
    const pieces = await makeUploadOptions();

    if (!pieces) {
      return;
    }

    const [prefix, options] = pieces;

    const client = new OSS(options);

    return new Promise((resolve, reject) => {
      const file = item.file;
      //处理FileReader
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = (e) => {
        const pathname = makeUploadName(prefix, file);

        if (!pathname) {
          return;
        }
        // oss上传
        client.put(pathname, file).then((res: any) => {
          let url = res.url;

          const files = [...filesList, { url }];
          setFilesList(files);
          // 确定
          onConfirm(files);
          resolve({ url: url });
        });
      };
    });
  };
  // 查看大图方法
  const onGetPreviewUrl = (index: number): Promise<string> => {
    return new Promise((resolve, reject) => {
      setPhotoVisible(true);
    });
  };
  const onPhotoDelete = (filesList: any) => {
    setFilesList(filesList);
    onConfirm(filesList);
  };

  const subjectBindState = async (subjectCode: string) => {
    try {
      const { data } = await api.getSubjectBindState(subjectCode);
      setBindState(data.bindState);
    } catch (error) {
      return Promise.reject(error);
    }
  };
  const getItemStateText = (reportState: number) => {
    switch (reportState) {
      case 2:
        return "重报";
      case 1:
        return "已上报";
      case 0:
        return "未上报";
    }
  };

  // 格式化时间
  const handleFormatDate = (date: string) => {
    if (!date) return;
    return moment(date).format("YYYY-MM-DD HH:mm");
  };

  // 查看报告
  const goReportRecord = (event: React.MouseEvent, row: ReportItem) => {
    event?.stopPropagation?.();
    const { code: scaleCode, name, reportState, isLook } = row;

    if (!isLook) {
      api.updateReadStatus(Number(row.id), subjectCode).then(() => {
        // 标记为已查看
      });
    }

    if (reportState === 1) {
      const subjectCode = props.match.params.id;
      props.history.push(
        `/reportRecord/${scaleCode}/${subjectCode}?scaleName=${name}`
      );
    }
  };

  // 重新上报提醒
  const goReportAgain = (event: React.MouseEvent, row: ReportItem) => {
    event?.stopPropagation?.();
    const { code: scaleCode, name, id } = row;

    const subjectCode = props.match.params.id;
    props.history.push(
      `/reportAgainTip/${scaleCode}/${subjectCode}?scaleName=${name}&scaleId=${id}`
    );
  };
  // 提醒
  const goReportTip = (event: React.MouseEvent, row: ReportItem) => {
    // 受试者名称
    const targetName = sessionStorage.getItem("targetName") || "受试者";
    if (!bindState) {
      return Toast.fail(`请先邀请${targetName}绑定信息`, 1);
    }
    event?.stopPropagation?.();
    const { code: scaleCode, name, id, code, arrival } = row;
    if (!arrival) {
      return Toast.fail("未到填写时间，请核查后再发起提醒！", 1);
    }
    const subjectCode = props.match.params.id;
    props.history.push(
      `/reportTip/${subjectCode}?scaleName=${name}&scaleId=${id}&scaleCode=${code}`
    );
  };
  // 图片上传
  const toPhotoUpload = (event: React.MouseEvent, row: ReportItem) => {
    const photos = (row.url || []).map((e) => {
      return {
        url: e,
      };
    });
    setScale(row);
    setFilesList(photos);
    event?.stopPropagation();
    setShowModal(true);
  };

  // 图片上传的权限控制
  let isShowPhoto = false;
 
  const token: any = JSON.parse(sessionStorage.getItem('token') || '{}');
  const projectRoleCode = sessionStorage.getItem('projectRoleCode');
  if (
    projectRoleCode !== "ReadOnly" &&
    token.roleCode !== "EDC_READ" &&
    token.roleCode !== "CALL_CENTER" 
  ) {
    isShowPhoto = true;
  }
  return selfReportedList?.length ? (
    <div className="report-container">
      <div className="report-header">患者自报</div>
      {selfReportedList.map((sp) => (
        <div
          className="report-item"
          data-state={sp?.reportState}
          key={sp.id}
          onClick={(e) => goReportRecord(e, sp)}
        >
          <div className="report-item--info">
            <div className="report-item--title">{sp.name}</div>
            {sp?.reportState === 1 ? (
              <div className="report-item--behavior">
                <span onClick={(e) => goReportAgain(e, sp)}>
                  重报
                  <RightOutline />
                </span>
                <span onClick={(e) => goReportRecord(e, sp)}>
                  问卷
                  <RightOutline />
                </span>
                <span onClick={(e) => goReportRecord(e, sp)}>
                  报告
                  <RightOutline />
                </span>
              </div>
            ) : (
              <div className="report-item--behavior">
                <span onClick={(e) => goReportTip(e, sp)}>
                  提醒
                  <RightOutline />
                </span>
              </div>
            )}

            { bindState === 1 && isShowPhoto == true && (
              <div className="report-item--behavior">
                <span onClick={(e) => toPhotoUpload(e, sp)}>
                  图片上传
                  <RightOutline />
                </span>
              </div>
            )}
          </div>
          <div className="report-item--right">
            <div className="report-item--state">
              <span className="report-state--text" data-state={sp?.reportState}>
                {getItemStateText(sp?.reportState)}
                {sp?.reportState > 0 &&
                  (sp?.isLook ? (
                    <i style={{ fontStyle: "normal", marginLeft: 5 }}>已查看</i>
                  ) : (
                    <i
                      style={{
                        fontStyle: "normal",
                        marginLeft: 5,
                        color: "orange",
                      }}
                    >
                      未查看
                    </i>
                  ))}
              </span>
              {sp?.reportState === 1 && (
                <span className="report-state--time">
                  {handleFormatDate(sp?.updateTime)}
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
      <PhotoSlider
        photoClosable
        bannerVisible={true}
        images={filesList && filesList.map((item: any) => ({ src: item.url }))}
        visible={photoVisible}
        onClose={() => {
          setPhotoVisible(false);
          // setShowModal(true);
        }}
        index={currentPhotoIndex}
        introVisible={true}
        onIndexChange={(i: any) => {
          setCurrentPhotoIndex(i);
        }}
      />

      <ActivityIndicator
        animating={loading}
        size={"small"}
        text={"正在上传图片"}
        toast
      />

      <Modal visible={showModal} animationType={"slide-up"}>
        <div>
          <div
            style={{
              textAlign: "left",
              fontSize: "16px",
              color: "#424347",
              padding: "10px",
              display: "flex",
              lineHeight: "18px",
              paddingBottom: "0",
            }}
          >
            <div
              style={{
                width: "6px",
                height: "18px",
                background: "#6c96f7",
                marginRight: "4px",
              }}
            ></div>
            <div>量表图片上传</div>
          </div>
          <div className="modal_scale">
            <ImagePicker
              filesList={filesList}
              onChange={onPhotoChange}
              multiple={false}
              max={8}
              mode="cover"
              onUpload={onUpload}
              width="22%"
              onFail={() => {
                Toast.fail("上传失败！", 1);
              }}
              onGetPreviewUrl={onGetPreviewUrl}
              config={["defaultDashed"]}
              disabled={false}
              onDelete={onPhotoDelete}
            />
          </div>
          <div className="saveBtn">
            <span
              onClick={() => {
                setShowModal(false);
              }}
              style={{
                marginRight: "6px",
                background: "white",
                color: "#6287EC",
                border: "1px solid #6287EC",
              }}
            >
              <IconFont
                style={{ padding: "0", marginRight: "4px" }}
                type="iconClose"
              ></IconFont>
              关闭
            </span>

            {/* <span onClick={onConfirm}>
              <img src={saveBtn} alt="save" />
              保存
            </span> */}
          </div>
        </div>
      </Modal>
    </div>
  ) : (
    <></>
  );
};

export default withRouter(PatientSelfReported);
